export default __webpack_public_path__ + "2d2018cfe9121304c87277025657038c.mp3";